import { Component, ErrorInfo } from 'react';
import { Button } from 'antd';
import Logger from './logger';
import styles from './errorboundary.module.css';
import { ExclamationCircleFilled } from '@ant-design/icons';

interface ErrorBoundaryState {
  hasError: boolean,
  error?: Error,
  eventId?: string
}

export default class ErrorBoundary extends Component<any, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false
  }
  
  static getDerivedStateFromError(error: Error) {
    return { error, hasError: true }
  }

  async componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const eventId = await Logger.logError(error, errorInfo);
    this.setState({ eventId });
  }
  
  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div className={styles.container}>
          <ExclamationCircleFilled />
          <h1 className={styles.title}>¡Oops!</h1>
          <h2 className={styles.subtitle}>Lo sentimos, algo falló</h2>
          
          <Button type="primary" onClick={() => window.location.reload()}>Recargar página</Button>
        </div>
      )
    }
    
    return this.props.children;
  }
}